
// import axios from 'axios';

// // Get token from session storage
// const currentUser = sessionStorage.getItem("currentUser");
// const token = sessionStorage.getItem(`token_${currentUser}`);

// // Create axios instance
// const instance = axios.create({
//   baseURL: window.location.hostname === 'localhost'
//     ? 'http://localhost:5000'
//     : 'https://sandbox.atslrail.com/api',
// });

// // Add request interceptor to include the token
// instance.interceptors.request.use(
//   config => {
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );

// export default instance;
// axiosInstance.js
import axios from 'axios';
import { getAuthToken } from './ utils/getToken';

const instance = axios.create({
  baseURL:""
    // window.location.hostname === 'localhost'
    //   ? ''
    //   : 'https://sandbox.atslrail.com',
});
console.log("hostname=",window.location.hostname);
instance.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
